export function sanitizeReportCode(reportCode: string) {
  return reportCode.replace(/-/g, '').trim()
}
